<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-danger opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Está enfrentando algum problema? Deseja tirar alguma dúvida ou dar
              seu feedback? Você veio ao lugar certo! Preencha os campos abaixo
              para enviar sua mensagem à empresa.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-8">
          <support-form to="/collaborator/support" :showHistory="true" />
        </div>
        <div class="col-lg-4 mt-4 mt-lg-0">
          <card shadow bodyClasses="pb-1" class="mb-4">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Treinamento</h3>
                </div>
              </div>
            </div>
            <template>
              <div class="row">
                <div class="col-12 text-left">
                  <ul v-for="(video, index) in videos" :key="index">
                    <li
                      class="cursor-pointer link"
                      @click="openLink(video.link)"
                      title="Abrir link"
                    >
                      {{ video.title }}
                      <i class="fas fa-video ml-1"></i>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "suporte_collaborator",
  data() {
    return {
      videos: [
        {
          title: "Iniciando no sistema e Home",
          link:
            "https://drive.google.com/file/d/16peuHTuibmruorNytojS5sf3Ch7DMUxw/view?usp=sharing"
        },
        {
          title: "Visualizando informações sobre os colaboradores",
          link:
            "https://drive.google.com/file/d/1kTEt6W2Dlc023gEh9-ANpiMJ2JCfnykx/view?usp=sharing"
        },
        {
          title: "Acessando a Trilha de Qualificação",
          link:
            "https://drive.google.com/file/d/16YeqOGldwre2CvknbqDqghjzOSzjmAUk/view?usp=sharing"
        },
        {
          title: "Gerenciando projetos e tarefas",
          link:
            "https://drive.google.com/file/d/1vQEm7-QfLQOy8Gh_-ZuwvgB7vsUW3Vzv/view?usp=sharing"
        },
        {
          title: "Conferindo informações da empresa em Comunidade",
          link:
            "https://drive.google.com/file/d/1EM3p-5VPr2_FIufwQVLJXdGSuuJs8A8o/view?usp=sharing"
        },
        {
          title: "Respondendo Enquetes e Ouvidoria",
          link:
            "https://drive.google.com/file/d/1HmR-ljK__UFwr9vXfr16FCeeQ2tGCJrU/view?usp=sharing"
        },
        {
          title: " Respondendo Pesquisas de Satisfação",
          link:
            "https://drive.google.com/file/d/1F-Cg7OPlMmdhzT14l2FloWvB0J1VCdpN/view?usp=sharing"
        },
        {
          title: "Conhecendo a Agenda",
          link:
            "https://drive.google.com/file/d/1lvp7nJIvMyC9tlA4uUBvD29ARdexih7O/view?usp=sharing"
        },
        {
          title: "Reservando Espaços",
          link:
            "https://drive.google.com/file/d/1r-flAUAxvaF_dpfJ4bicZ5RQ5WBFGE7H/view?usp=sharing"
        },
        {
          title: "Configurações e Suporte",
          link:
            "https://drive.google.com/file/d/1XyQ4VV9r_p9YaY48g9SCgNrtNlfekQPp/view?usp=sharing"
        }
      ]
    };
  },
  methods: {
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    }
  }
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.link {
  color: #5e72e4;
}
.link:hover {
  color: #233dd2;
}
</style>
